<template>
    <v-container :fluid="true" class="pt-0 pb-0">
        <v-row>
            <v-col cols="6">
                <v-autocomplete
                    v-model="value_provider"
                    :items="debts"
                    dense
                    solo
                    clearable 
                    clear-icon="far fa-times-circle"               
                    label="Proveedores"
                    persistent-hint
                    :item-text="customText"
                    item-value="id"
                    hide-details
                    @change="handleSelecteProvider"
                    :filter="customFilter"
                >
                    <template v-slot:item="data">
                        <v-list-item-content>
                            <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                            <v-list-item-subtitle>RUC: {{ data.item.document }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="1">
                <v-btn-toggle
                    v-model="type_view"
                    mandatory
                    dense
                    class="float-right"
                    @change="handleChangeTypeView"
                    >
                    <v-btn>
                        <v-icon size="18">fas fa-border-all</v-icon>
                    </v-btn>
                    <v-btn>
                        <v-icon size="18">fas fa-bars</v-icon>
                    </v-btn>                        
                </v-btn-toggle>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'FilterAccount',
    data() {
        return {
            type_view: 1,
            value_provider: '',
        }
    },
    computed: {
        ...mapState('provider', [
            'debts'
        ])
    },
    methods: {
        ...mapActions('provider', [
            'getDebts',
            'runSetTypeView'
        ]),
        customText(item){
            let text = item.name
            
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();
            }

            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();
            }
            
            let searchText = queryText.toLowerCase()


            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleSelecteProvider(value){            
            let provider_id = null            
            if(value !== undefined && value !== null){
                provider_id = value
            }
            this.searchDebts(null, provider_id)
        },
        searchDebts(type_customer = null, provider_id = null){
            let request = {
                params: {
                    provider_id: provider_id,
                    type_document: type_customer
                }
            }
            this.getDebts(request)
        },
        handleChangeTypeView(val){
            this.runSetTypeView(val)
        }
    }
}
</script>

<style>

</style>